import * as Sentry from '@sentry/react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

import { ErrorPage } from '../ErrorPage/ErrorPage';

const notifySentry = (error: Error) => {
  Sentry.captureException(error);
};

export function ErrorBoundary({ children }: { children: React.ReactNode }) {
  const resetPage = () => {
    window.location.reload();
  };

  return (
    <ReactErrorBoundary
      FallbackComponent={ErrorPage}
      onReset={resetPage}
      onError={notifySentry}
      resetKeys={[window.location.pathname]}
    >
      {children}
    </ReactErrorBoundary>
  );
}
